import { createRequest } from '../helpers/api_utils';
import { apiUrl } from './api_url';

export type InviteDetails = {
  success: boolean;
  email: string;
  firstName: string;
  lastName: string;
  organizationName: string | null;
  isCandidate: boolean;
  nextPath?: string;
  methods: { password: boolean; ssoOptions?: { provider: string; label: string; kind: string }[] };
  error?: string;
};

export function getInvite(token: string) {
  return fetch(createRequest(`${apiUrl}/auth/invite/${encodeURIComponent(token)}`, 'GET', 'application/json', false));
}

export function acceptInvite(token: string, password: string) {
  return fetch(createRequest(`${apiUrl}/auth/invite/accept`, 'POST', 'application/json', false, { token, password }));
}

export function resendInvite(email: string) {
  return fetch(createRequest(`${apiUrl}/auth/invite/resend`, 'POST', 'application/json', false, { email }));
}

export function confirmPasswordReset(token: string, password: string) {
  return fetch(createRequest(`${apiUrl}/password/reset`, 'POST', 'application/json', false, { token, password }));
}
